module.exports = __webpack_public_path__ + "static/media/vw-transporter1.29f7f728.jpg";